module.exports = __webpack_public_path__ + "static/selfish-reasons-to-have-more-kids-d595b004790cbcd4c986bd78ea5857a9.jpg";